import { DynamicFormServiceService } from './../../services/dynamic-form-service.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { FieldConfig } from 'src/app/core/interfaces/field-config';

@Component({
    selector: 'app-date-time-picker-form',
    templateUrl: './date-time-picker-form.component.html',
    styleUrls: ['./date-time-picker-form.component.scss'],
    standalone: false
})
export class DateTimePickerFormComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  isRequired: boolean;
  hideRequiredMarker = true;

  constructor(private dynamicService: DynamicFormServiceService) { }

  ngOnInit() {
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
    if (this.isRequired) {
      this.group.get(this.field.labelCode).setValidators(Validators.required);
      this.group.updateValueAndValidity();
    }
  }
}
